import React, { useState, useEffect } from 'react';
import vr from '../../../../utils/Verifiers';
import CloseButton from '../../../sharecomponents/CloseButton';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import { getDate, dateFormatConDiaYHoraShort } from '../../../../utils/DateFunctions';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const ReportesOrdenesTrabajo = (p) => {
    const [semana, setsemana] = useState({ semana_inicio: p.semana, semana_fin: p.semana });
    const [semanas, setsemanas] = useState(p.semanas);
    const [reporte, setreporte] = useState([]);
    const close = p.close || (() => { });

    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });

    const pdf_width = 1250;
    const pdf_height = pdf_width * 1.294117647058824;

    useEffect(() => {
        setsemanas(p.semanas);
        getReport(p.semana, p.semana);
        setreporte([]);
    }, [p.semana, p.semanas]);

    async function getReport(inicio, fin) {
        const data = { semana_inicio: inicio, semana_fin: fin };
        setsemana(data);
        const resp = await vr.getDataAPI('ordenes_trabajo/incompleto/reporte', data, setloader, setdialog);
        if (!resp || !resp.estatus) return;
        setreporte(agruparPorPagina(resp.data));
    }

    const createPDF = async () => {
        setloader(true);
        const doc = new jsPDF({
            orientation: 'portrait', // 'portrait' para retrato, 'landscape' para apaisado
            unit: 'mm',
            format: [215.9, 279.4], // [ancho, alto]
        });

        for (let i = 0; i < reporte.length; i++) {
            let id = "pagina" + i;
            const componentRef = document.getElementById(id); // Reemplaza con el ID de tu componente

            if (componentRef) {
                const canvas = await html2canvas(componentRef, { scale: 1.3 });
                const imgData = canvas.toDataURL('image/png');

                // Calcula el ancho y el alto de la imagen en el PDF
                const imgWidth = 215.9; // Ancho de la página en mm (A4)
                const imgHeight = 279.4;

                // Agrega la imagen como una nueva página al PDF
                if (i > 0) {
                    doc.addPage();
                }
                doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            }
        }

        // Guarda el PDF como un solo archivo
        doc.save(`REP_ORDENES_TRABAJO_${semana.semana_inicio}_${semana.semana_fin}`);
        setloader(false);
    };

    function calcularAlturaEmpleado(empleado) {
        const nombre = 22.5;
        const semanas_nombres = Object.keys(empleado.semanas);
        const semanas = semanas_nombres.length * 30;
        let dias = 0;
        semanas_nombres.forEach(semana => {
            dias += Object.keys(empleado.semanas[semana]).length;
        });
        return nombre + semanas + (dias * 18);
    }

    const agruparPorPagina = (reportes) => {
        if (reportes.length === 0) return [];
        const alturaMaxima = pdf_height - 50;
        let totalAltura = 0;
        const grupos = [[]];
        let grupoIndex = 0;
        const len = reportes.length;

        for (let i = 0; i < len; i++) {
            const altura = calcularAlturaEmpleado(reportes[i]);
            const total = totalAltura + altura;
            if (total <= alturaMaxima) {
                totalAltura += altura;
                grupos[grupoIndex].push(reportes[i],);
            } else {
                totalAltura = altura;
                grupoIndex++;
                grupos.push([]);
                grupos[grupoIndex].push(reportes[i]);
            }
        }

        return grupos;
    }

    const reporteEmpleado = (data) => {
        const nombre = data.empleado;
        const semanas = Object.keys(data.semanas).length;
        const asignado = data.total_asignado;
        const incompleto = data.total_incompleto;
        return (<div className="bw m-0 p-0 border-secondary mb-2 p-0" id={`empleado-${nombre}`} style={{ '--bw': '1200px' }}>
            <div className={`row d-flex m-0 p-0 justify-content-start`}>
                <div className="bw m-0 p-0 text-bold" style={{ '--bw': '300px', backgroundColor: '#F5F5F5' }}>{nombre}</div>
                <div className="bw m-0 p-0 text-bold" style={{ '--bw': '200px', backgroundColor: '#F5F5F5' }}>{asignado}<span className='text-300 ms-2'>ch Asignadas</span></div>
                <div className="bw m-0 p-0 text-bold text-red3" style={{ '--bw': '200px', backgroundColor: '#F5F5F5' }}>{incompleto}<span className='text-300 ms-2 text-dark'>ch Faltantes</span></div>
                <div className="bw m-0 p-0 text-bold text-muted round-top-right-xxl" style={{ '--bw': '120px', backgroundColor: '#F5F5F5' }}>{semanas}<span className='text-300 ms-2'>Semanas</span></div>
                {reportePorSemana(data)}
            </div>
        </div>)
    }

    const reportePorSemana = (dataRecive) => {
        const data = JSON.parse(JSON.stringify(dataRecive));
        const semanas = Object.keys(data.semanas);
        const len = semanas.length;

        for (let i = 0; i < len; i++) {
            const semana = semanas[i];
            const dias = Object.keys(data.semanas[semana]);
            let asignado = 0;
            let incompleto = 0;
            for (let j = 0; j < dias.length; j++) {
                const dia = dias[j];
                asignado += data.semanas[semana][dia].asignado || 0;
                incompleto += data.semanas[semana][dia].incompleto || 0;
            }
            data.semanas[semana].incompleto = incompleto;
            data.semanas[semana].total = asignado + incompleto;
            data.semanas[semana].dias = dias.length;
        }

        return semanas.map((sem, index) => <React.Fragment key={'semana' + index}>
            <div className="w m-0 p-0" style={{ '--w': '100%' }}></div>
            <div className="bw" style={{ '--bw': '100px' }}></div>
            <div className="bw m-0 p-0 text-bold border-bottom border-dark" id={`semana-${sem}`} style={{ '--bw': '100px' }}><span className='text-xs me-2'>Semana</span>{sem}</div>

            <div className="bw m-0 p-0 text-bold border-bottom border-dark" style={{ '--bw': '200px' }}>
                {data.semanas[sem].total}
                <span className='text-300 ms-2'>ch Asignadas</span>
            </div>
            <div className="bw m-0 p-0 text-bold text-red3 border-bottom border-dark" style={{ '--bw': '200px' }}>
                {data.semanas[sem].incompleto}
                <span className='text-300 ms-2 text-dark'>ch Faltantes</span>
            </div>
            {reportePorDia(dataRecive.semanas[sem], sem)}
            <div className="w m-0 p-0 mb-2" style={{ '--w': '100%' }}></div>
        </React.Fragment>);
    }

    const reportePorDia = (data, semana) => {
        const dias = Object.keys(data);
        return dias.map((dia, index) => <React.Fragment key={`dia ${index} ${semana}`}>
            <div className="w m-0 p-0" style={{ '--w': '100%' }}></div>
            <div className="bw" style={{ '--bw': '200px' }}></div>
            <div className="bw m-0 p-0 text-bold border-bottom lh1 text-secondary" style={{ '--bw': '100px' }}>
                {dia}
            </div>
            <div className="bw m-0 p-0 text-bold border-bottom lh1 text-secondary" style={{ '--bw': '200px' }}>
                {data[dia].asignado}
                <span className='text-300 ms-2'>ch Asignadas</span>
            </div>
            <div className="bw m-0 p-0 text-bold border-bottom lh1 text-red35" style={{ '--bw': '120px' }}>
                {data[dia].incompleto}
                <span className='text-300 ms-2  text-secondary'>ch Faltantes</span>
            </div>
        </React.Fragment>);
    }

    return (
        <>
            <div className='vw-100 h-100 blur-xl bg-white5' style={vr.floatPageStyle()}>
                <div className={`row d-flex m-0 p-0 justify-content-center w-100`}>
                    <CloseButton close={close} />

                    <div className='bw m-0 p-0 bg-white shadow round-s mb-3' style={{ '--bw': `${pdf_width}px` }}>
                        <div className={`row d-flex m-0 p-0 justify-content-around w-100 p-2`}>
                            <div className="w-100 text-center h3 text-300" >REPORTE DE ORDENES DE TRABAJO DE SIEMBRA INCOMPLETAS</div>
                            <div className='w-100'>
                                <div className={`row d-flex m-0 p-0 justify-content-center`}>
                                    <div className="bw-150 m-1" >
                                        <label className='text-bold w-100'>Semana inicial</label>
                                        <select className='form-control text-center text-bold' value={semana.semana_inicio} onChange={(e) => getReport(e.target.value, semana.semana_fin)}>
                                            {semanas.map((sem, index) => (
                                                <option key={index} value={sem.semana}>{sem.semana}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="bw-150 m-1" >
                                        <label className='text-bold w-100'>Semana final</label>
                                        <select className='form-control text-center text-bold' value={semana.semana_fin} onChange={(e) => getReport(semana.semana_inicio, e.target.value)}>
                                            {semanas.map((sem, index) => (
                                                <option key={index} value={sem.semana}>{sem.semana}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="bw-150 m-1 p-0 pt-4 d-flex row-column justify-content-end align-items-center" >
                                        <button className='btn btn-success shadow' disabled={reporte.length === 0} onClick={createPDF}>Descargar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w m-0 p-0" style={{ '--w': '100%' }}></div>
                    {!loader && reporte.length === 0 && <div className='w-100 h-100 d-flex justify-content-center align-items-center h3 text-300 mt-5 p-2 round-s bg-white'>
                        No hay registros de órdenes de trabajo incompletas para el rango de semanas <span className='text-bold ms-2'>{semana.semana_inicio} - {semana.semana_fin}</span>
                    </div>}

                    {reporte.map((item, index) => <React.Fragment key={'rep0' + index} >
                        <div className="w mt-3" style={{ '--w': '100%' }}></div>
                        <div className='m-0 pt-0 pb-0 pe-0 bg-white shadow round-m ' id={`pagina${index}`} style={{ width: `${pdf_width}px`, height: `${pdf_height}px`, paddingLeft: "200px" }}>
                            <div className={`row d-flex m-0 p-0 justify-content-around w-100`}>
                                <div className="w opacity-70 text-end" style={{ '--w': '100%', padding: "18px 15px 10px 15px" }} id={"reporte-titulo" + index}>
                                    REPORTE DE ORDENES DE TRABAJO DE SIEMBRA INCOMPLETAS
                                    <span className='text-bold text-secondary ms-4' style={{ 'fontStyle': 'italic' }}>
                                        <span className='text-400 me-1'>Semanas:</span>
                                        {semana.semana_inicio} - {semana.semana_fin}
                                    </span>
                                    <span className='text-bold text-secondary ms-4' style={{ 'fontStyle': 'italic' }}>
                                        <span className='text-400 me-1'>Fecha de impresión:</span>
                                        {dateFormatConDiaYHoraShort(getDate())}
                                    </span>
                                    <span className='text-bold text-secondary ms-4' style={{ 'fontStyle': 'italic' }}>
                                        Pagina {index + 1} de {reporte.length}
                                    </span>
                                </div>
                                {item.map((data, idx) => <React.Fragment key={'rep-empleado' + index + idx}>
                                    {reporteEmpleado(data)}
                                </React.Fragment>)}
                            </div>
                        </div>
                        <div className="w mt-2" style={{ '--w': '100%' }}></div>
                    </React.Fragment>)}
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </>

    )
}

export default ReportesOrdenesTrabajo;